/**
 * Moves the in-form variant picker (.product__selectors) into the
 * "Variant Picker Position" block, so it can render above "Choose Quantity".
 *
 * The node is MOVED, not cloned. Safe because the theme's ProductForm binds
 * change listeners per-element and caches the input refs at init
 * (theme.dev.js: _initInputs), and reads them by reference afterwards — so the
 * picker keeps driving price/image/variant once moved. The form's
 * [name="id"] hidden input stays in the <form>, so Add-to-cart is unaffected
 * (option radios are never submitted; the id input is).
 *
 * TIMING: theme.js is deferred, so ProductForm caches the option inputs AFTER
 * DOMContentLoaded. We must move the picker only AFTER that init — moving it
 * earlier makes the theme cache an empty option list and every variant lookup
 * returns null (prices/ATC stop updating). The theme fires theme:variant:change
 * at the end of init, and window.load is always after deferred scripts, so both
 * are safe triggers. We never move on DOMContentLoaded.
 *
 * ponytail: relocate is idempotent and re-runs on shopify:section:load for the
 * theme editor. Upgrade path: if multiple variant options ever need to land in
 * different positions, split .product__selectors per option instead.
 */
(function () {
  function relocate() {
    document.querySelectorAll('[data-pack-size-target]').forEach(function (target) {
      if (target.querySelector('.product__selectors')) return; // already moved
      var container = target.closest('[data-product]') || target.closest('.shopify-section');
      if (!container) return;
      var picker = container.querySelector('[data-form-wrapper] .product__selectors');
      if (picker) target.appendChild(picker);
    });
  }

  if (document.readyState === 'complete') {
    relocate(); // script injected after load (e.g. theme editor) — init already done.
  } else {
    window.addEventListener('load', relocate); // guaranteed after deferred theme.js init.
  }

  // Document-level listeners: add once (script re-executes on section reload).
  if (!window.__packSizeRelocateInit) {
    window.__packSizeRelocateInit = true;
    // Earliest safe trigger: fires at ProductForm init (and on every switch).
    document.addEventListener('theme:variant:change', relocate);
    document.addEventListener('shopify:section:load', relocate);
  }
})();
